import { render, staticRenderFns } from "./MultiselectSearchInput.vue?vue&type=template&id=2dff20f1"
import script from "./MultiselectSearchInput.vue?vue&type=script&lang=js"
export * from "./MultiselectSearchInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports